import axios from "axios";

const api = axios.create({
  baseURL: "/api", // change to your backend URL
 
});

api.interceptors.request.use((config) => {
  const user = sessionStorage.getItem("user");
  if (user) {
    const { token } = JSON.parse(user);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  (res) => res,
  (err) => {
    // if (err.response?.status === 401) {
    //   window.location.href = "/login";
    // }

    if (err.response?.status === 403) {
      alert("You are not allowed to perform this action");
    }

    return Promise.reject(err);
  }
);

export default api;